/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import _ from 'lodash';
import {UserProfilePageComponent} from './user-profile-page.component';
import {UserProfileResource} from '../../../components/api/resources/resource/user-profile.resource';


export function userProfileStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('user-profiles.user-profile', UserProfileResource, 'app.adm', 'app/admin', null);
        $stateProvider.state('app.adm.user-profile',
          _.assign(rh.item(), {
            url: '/user-profile',
            data: {
              app: ['ADVERTISING', 'DATA', 'POLITICAL']
            },
            views: {
              'content@app': {
                component: UserProfilePageComponent
              },
              'title@app': stateTitleView()
            },
          }));
  }, adnRouterHelper);
}
